export const DEFAULT_SOLUTION_CONTEXT_ID = 'bddf47fb-8b6b-4be3-1ee1-dfa284cb8962'
export const NO_SOLUTION_CONTEXT_ID = '2da3e9b2-fa55-46f3-9123-5fcd93e4c446'
